export default __webpack_public_path__ + "d24c3cc97d05f545274c0f0084c54738.png";